module.exports = __webpack_public_path__ + "static/media/aff.9ac0eaec.png";